<template>
  <app-page-subsection
    id="packages"
    class="@container"
    :title="{ tag: 'h3', text: $t('course.page.pricing_title') }"
  >
    <template #append-header>
      <app-button
        color="dark"
        target="_blank"
        to="/getting-financed"
        variant="link"
      >
        {{ $t("course.page.getting_financed_label") }}
      </app-button>
    </template>

    <div
      class="grid overflow-hidden rounded-2xl border-2 border-primary/15 bg-clip-padding shadow-lg @3xl:auto-cols-fr @3xl:grid-flow-col"
      :class="{
        'bg-accent-50': packages.some((item) => item.type === 'PREMIUM'),
      }"
    >
      <course-package-card
        v-for="(item, index) in packages"
        :key="item.type"
        :class="[
          packageCardClasses,
          {
            'bg-white': item.type === 'BASIC',
            'bg-accent-50': item.type === 'PREMIUM',
            'border-b-2 border-primary/15 @3xl:border-r-2':
              index < packages.length - 1,
          },
        ]"
        :package="item"
      >
        <template #append>
          <app-button
            v-if="
              item._links?.enrol &&
              nextSession &&
              !isRegisteredToCourseSession(nextSession.id)
            "
            block
            color="primary"
            data-cy-enrol-package
            size="lg"
            :to="item._links.enrol"
            @click="$analytics.track('checkout_started')"
          >
            {{ $t("course.page.pricing_cta_label") }}
          </app-button>
        </template>
      </course-package-card>

      <course-package-card
        class="rounded-2xl bg-primary-900 text-white"
        :class="packageCardClasses"
        :package="privateCoursePackage"
      >
        <template #append>
          <growth-contact-button
            block
            origin="course"
            origin_page_action="packages_intra_cta"
            :origin_page_id="course.slug"
            size="lg"
          >
            {{ $t("course.page.privatization.package_card.cta") }}
          </growth-contact-button>
        </template>
      </course-package-card>
    </div>
  </app-page-subsection>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CoursePackageWithDetailsView } from "~/business-areas/course-package/composables/course-packages.hook";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";

defineProps<{
  course: CoursePageView;
  packages: CoursePackageWithDetailsView[];
  nextSession?: CourseSessionView;
}>();

const { $analytics } = useNuxtApp();
const { isRegisteredToCourseSession } = useLearnerProfile();

const packageCardClasses = ["p-8"];

const { t, tm, rt } = useI18n();
const privateCoursePackage = computed<CoursePackageWithDetailsView>(() => {
  return {
    price: {
      formatted: "",
      htmlFormatted: `<span class='font-normal'>${t(
        "course.page.privatization.package_card.price_label",
      )}</span>`,
      amount: 0,
      currency: "",
    },
    // @ts-expect-error .map on unknown
    contentItems: tm("course.page.privatization.package_card.items").map(
      // @ts-expect-error implicit any type
      (key) => rt(key),
    ),
    featured: {
      label: t("course.page.privatization.package_card.options_label"),
      icons: ["ph:graduation-cap", "ph:handshake"],
    },
    keys: [],
    type: "PRIVATE",
  };
});
</script>
